import { createServerFn } from '@tanstack/react-start';
import { defineQuery } from 'groq';

import type { BotPolicyQueryResult } from '@/sanity.types';

import { createSanityClient } from './client';
import { legalDocumentProjection } from './legal-document';

export type BotPolicy = NonNullable<BotPolicyQueryResult>;

const botPolicyQuery = defineQuery(`*[
  _type == "botPolicy" &&
  _id == "botPolicy"
][0] ${legalDocumentProjection}`);

/** Public server function: it only reads the published BudgyBot crawler page from Sanity. */
export const getBotPolicy = createServerFn({ method: 'GET' }).handler(
  async (): Promise<BotPolicy | null> => {
    const client = createSanityClient();

    try {
      return await client.fetch(botPolicyQuery);
    } catch (error) {
      console.error('Failed to load Sanity BudgyBot crawler page', error);
      return null;
    }
  },
);
